export const SK_WL_DEFAULT_VALUE = () => ({
  otherTests: 'B12, CRP, Total Insulin',
  CBC: true,
  LYTE4: true,
  CREAT: true,
  GLUFA: true,
  HMA1C: true,
  LIPNF: true,
  ALB: true,
  ALP: true,
  ALT: true,
  LIP: true,
  FER: true,
  THYSA: true
});

export const SK_TRT_DEFAULT_VALUE = () => ({
  otherTests: 'Testosterone (Free and total), B12, CRP, Total Insulin',
  male: true,
  CBC: true,
  LYTE4: true,
  CREAT: true,
  GLUFA: true,
  HMA1C: true,
  LIPNF: true,
  ALB: true,
  ALP: true,
  ALT: true,
  LIP: true,
  FER: true,
  THYSA: true,
  FSHLH: true,
  EDIOL: true,
  PRL: true,
  PSA: true
});

export const SK_LGV_DEFAULT_VALUE = ({ customer, organization }) => {
  const jackLgvOtherTests =
    'Lipoprotein(a), Cortisol (random), Free T3, Nucleated RBC (NRBC)';
  const jillLgvOtherTests = 'Testosterone (Total), DHEA-S, Free T3, Lipoprotein(a), Cortisol (random), Nucleated RBC (NRBC)';
  const defaultsByProfile = {
    jack_health: {
      ...SK_TRT_DEFAULT_VALUE(),
      IRONB: true,
      MG: true,
      URIC: true,
      PSA: false,
      AST: true,
      FRT4: true,
      CA: true,
      PHOS: true,
      GGT: true,
      otherTests: `${SK_TRT_DEFAULT_VALUE().otherTests}, ${jackLgvOtherTests}`
    },
    jill_health: {
      ...SK_WL_DEFAULT_VALUE(),
      IRONB: true,
      PRGE: true,
      EDIOL: true,
      FSHLH: true,
      PRL: true,
      FRT4: true,
      CA: true,
      PHOS: true,
      GGT: true,
      MG: true,
      URIC: true,
      AST: true,
      otherTests: `${SK_WL_DEFAULT_VALUE().otherTests}, ${jillLgvOtherTests}`
    }
  };
  const normalizedGender = customer?.gender?.toLowerCase?.();
  if (normalizedGender === 'male' || normalizedGender === 'm') {
    return defaultsByProfile.jack_health;
  }
  if (normalizedGender === 'female' || normalizedGender === 'f') {
    return defaultsByProfile.jill_health;
  }
  return defaultsByProfile[organization] || defaultsByProfile.jack_health;
};

const SK_LGV_PAID_EXTRA_JACK = {
  lgvPaid_danTalya: true,
  lgvPaid_docFee: true,
  lgvPaid_shbg: true,
  lgvPaid_psaScreening: true,
  lgvPaid_vitaminD25: true,
  lgvPaid_apob: false,
  lgvPaid_fastingNo: false,
  lgvPaid_fastingYes: true,
  lgvPaid_fastingHours: '8-10',
};

const SK_LGV_PAID_EXTRA_JILL = {
  lgvPaid_danTalya: true,
  lgvPaid_docFee: true,
  lgvPaid_shbg: false,
  lgvPaid_psaScreening: false,
  lgvPaid_vitaminD25: true,
  lgvPaid_apob: true,
  lgvPaid_fastingNo: false,
  lgvPaid_fastingYes: true,
  lgvPaid_fastingHours: '8-10',
};

export const SK_LGV_PAID_DEFAULT_VALUE = ({ customer, organization }) => {
  const isMale = ['male', 'm'].includes(customer?.gender?.toLowerCase?.());
  return {
    ...SK_LGV_DEFAULT_VALUE({ customer, organization }),
    lgvPaid_healthNumber: customer?.identifiers?.[0]?.hcNum || '',
    ...(isMale ? SK_LGV_PAID_EXTRA_JACK : SK_LGV_PAID_EXTRA_JILL),
  };
};
